// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"BaseIcon_icon-wrapper_S0p1H","icon-base":"BaseIcon_icon-base_kE222"};